



































































import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      textArr: [
        { img: require('../../../assets/img/index/icon_vip_priority loan@3x.png'), title: "额度灵活", text: "以实际审核额度为准" },
        { img: require('../../../assets/img/index/icon_vip_priority loan@3x(2).png'), title: "选择丰富", text: "可分3/6/12期" },
        { img: require('../../../assets/img/index/icon_vip_priority loan@3x(1).png'), title: "机器审核", text: "以实际审批时间为准" },
        { img: require('../../../assets/img/index/icon_vip_priority loan@3x(3).png'), title: "操作便捷", text: "全流程线上操作" },
      ],
    };
  },
  methods: {},
});
